import PropTypes from 'prop-types'
import { X } from 'lucide-react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@components/ui/dialog'
import { AdasTypography } from './AdasTypography'
import { AdasButton } from './AdasButton'
import { cn } from 'lib/utils'

export const AdsCustomModal = ({
  title,
  open,
  description = '',
  onClose,
  children,
  titleConfig = {},
  successButtonTitle = '',
  successButtonConfig = {},
  cancelButtonTitle = '',
  cancelButtonConfig = {},
  hideCloseIcon = false
}) => {
  const handleClose = () => onClose({ type: 'close' })
  const handleConfirm = () => onClose({ type: 'confirm' })

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) handleClose()
      }}
    >
      <DialogContent className='sm:max-w-lg' hideDefaultClose>
        <DialogHeader>
          <DialogTitle className={cn('font-bold text-lg', titleConfig?.className)}>
            {titleConfig?.startIcon && <span className='mr-2'>{titleConfig.startIcon}</span>}
            {title}
          </DialogTitle>
          {!hideCloseIcon && (
            <AdasButton buttonType='iconButton' aria-label='close' onClick={handleClose} className='absolute right-4 top-4'>
              <X className='h-4 w-4' />
            </AdasButton>
          )}
        </DialogHeader>
        <div className='mt-2'>
          {description && (
            <AdasTypography variant='body1' className='text-text-secondary mb-2'>
              {description}
            </AdasTypography>
          )}
          {children}
          <div className='flex justify-end gap-2 mt-6'>
            {cancelButtonTitle && (
              <AdasButton onClick={handleClose} {...cancelButtonConfig}>
                {cancelButtonTitle}
              </AdasButton>
            )}
            {successButtonTitle && (
              <AdasButton variant='contained' onClick={handleConfirm} {...successButtonConfig}>
                {successButtonTitle}
              </AdasButton>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

AdsCustomModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  description: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  titleConfig: PropTypes.object,
  successButtonTitle: PropTypes.string,
  successButtonConfig: PropTypes.object,
  cancelButtonTitle: PropTypes.string,
  cancelButtonConfig: PropTypes.object,
  hideCloseIcon: PropTypes.bool
}
